module.exports = __webpack_public_path__ + "img/search_icon.167f4407.svg";